<div class="product-cards" #productCards data-section-id="product-cards-section" data-section-name="Product Cards">
  <app-container>
    <!-- Vista de tabla para desktop -->
    <div class="product-cards__table product-cards__table--desktop">
      <!-- Header de la tabla -->
      <div class="product-cards__header">
        <div class="product-cards__header-cell">
          <h3 class="product-cards__header-title">{{ caracteristicasAvance.title }}</h3>
        </div>
        <div class="product-cards__header-cell">
          <h3 class="product-cards__header-title">{{ advanceCard.title }}</h3>
        </div>
        <div class="product-cards__header-cell" >
          <h3 class="product-cards__header-title">{{ superAdvanceCard.title }}</h3>
        </div>
      </div>

      <!-- Filas de características -->
      <div class="product-cards__row" *ngFor="let i = index; let feature of caracteristicasAvance.features">
        <div class="product-cards__cell">
          <div class="product-cards__feature">
            <div class="product-cards__icon">
              <i [class]="'icon-' + feature.icon"></i>
            </div>
            <div class="product-cards__content">
              <h4 class="product-cards__feature-title">{{ feature.title }}</h4>
              <p class="product-cards__feature-description">{{ feature.description }}</p>
            </div>
          </div>
        </div>
        <div class="product-cards__cell">
          <div class="product-cards__feature">
            <div class="product-cards__icon">
              <i [class]="'icon-' + advanceCard.features[i].icon"></i>
            </div>
            <div class="product-cards__content">
              <h4 *ngIf="advanceCard.features[i].title.length" class="product-cards__feature-title">{{ advanceCard.features[i].title }}</h4>
              <p class="product-cards__feature-description">{{ advanceCard.features[i].description }}</p>
              <ul class="list-table" *ngIf="advanceCard.features[i].descriptionList?.length">
              <li *ngFor="let item of advanceCard.features[i].descriptionList">- {{ item }}</li>
            </ul>
            </div>
          </div>
        </div>
        <div class="product-cards__cell">
          <div class="product-cards__feature">
            <div class="product-cards__icon">
              <i [class]="'icon-' + superAdvanceCard.features[i].icon"></i>
            </div>
            <div class="product-cards__content">
              <h4 *ngIf="superAdvanceCard.features[i].title.length" class="product-cards__feature-title">{{ superAdvanceCard.features[i].title }} </h4>
              <p class="product-cards__feature-description">{{ superAdvanceCard.features[i].description }}</p>
               <ul class="list-table" *ngIf="superAdvanceCard.features[i].descriptionList?.length">
              <li *ngFor="let item of superAdvanceCard.features[i].descriptionList">- {{ item }}</li>
            </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Fila de acciones -->
      <div class="product-cards__actions-row">
        <div class="product-cards__cell">

        </div>
        <div class="product-cards__cell">
          <div class="product-cards__actions">
            <a [href]="advanceCard.ctaLink" class="product-cards__cta" (click)="onAdvanceCTAClick()">
              {{ advanceCard.ctaText }}
            </a>
            <p class="product-cards__legal-link">
              Sujeto a evaluación crediticia
            </p>
          </div>
        </div>
        <div class="product-cards__cell">
          <div class="product-cards__actions">
            <a [href]="superAdvanceCard.ctaLink" class="product-cards__cta" (click)="onSuperAdvanceCTAClick()">
              {{ superAdvanceCard.ctaText }}
            </a>
            <p class="product-cards__legal-link">
              Sujeto a evaluación crediticia
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Vista de lista para móvil -->
    <div class="product-cards__mobile">
      <!-- Grupo 1: Advance Card -->
      <div class="product-cards__mobile-group">
        <div class="product-cards__mobile-header">
          <h3 class="product-cards__mobile-title">{{ advanceCard.title }}</h3>
        </div>

        <div class="product-cards__mobile-features">
          <div class="product-cards__mobile-feature" *ngFor="let i = index; let feature of caracteristicasAvance.features">
            <div class="product-cards__feature">
              <div class="product-cards__icon">
                <i [class]="'icon-' + feature.icon"></i>
              </div>
              <div class="product-cards__content">
                <h4 class="product-cards__feature-title">{{ feature.title }}</h4>
                <h5 class="product-cards__feature-subtitle">{{ advanceCard.features[i].title }}</h5>
                <p class="product-cards__feature-description">{{ advanceCard.features[i].description }}</p>
                <ul class="list-table" *ngIf="advanceCard.features[i].descriptionList?.length">
                  <li *ngFor="let item of advanceCard.features[i].descriptionList">- {{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="product-cards__mobile-actions">
          <a [href]="advanceCard.ctaLink" class="product-cards__cta" (click)="onAdvanceCTAClick()">
            {{ advanceCard.ctaText }}
          </a>
          <a [routerLink]="advanceCard.legalLink" class="product-cards__legal-link" (click)="onAdvanceLegalClick()">
            Revisar bases legales
          </a>
        </div>
      </div>

      <!-- Grupo 2: Super Advance Card -->
      <div class="product-cards__mobile-group">
        <div class="product-cards__mobile-header">
          <h3 class="product-cards__mobile-title">{{ superAdvanceCard.title }}</h3>
        </div>
        <div class="product-cards__mobile-features">
          <div class="product-cards__mobile-feature" *ngFor="let i = index; let feature of caracteristicasAvance.features">
            <div class="product-cards__feature">
              <div class="product-cards__icon">
                <i [class]="'icon-' + feature.icon"></i>
              </div>
              <div class="product-cards__content">
                <h4 class="product-cards__feature-title">{{ feature.title }}</h4>
                <h5 class="product-cards__feature-subtitle">{{ superAdvanceCard.features[i].title }}</h5>
                <p class="product-cards__feature-description">{{ superAdvanceCard.features[i].description }}</p>
                <ul class="list-table" *ngIf="superAdvanceCard.features[i].descriptionList?.length">
                  <li *ngFor="let item of superAdvanceCard.features[i].descriptionList">- {{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="product-cards__mobile-actions">
          <a [href]="superAdvanceCard.ctaLink" class="product-cards__cta" (click)="onSuperAdvanceCTAClick()">
            {{ superAdvanceCard.ctaText }}
          </a>
          <a [routerLink]="superAdvanceCard.legalLink" class="product-cards__legal-link" (click)="onSuperAdvanceLegalClick()">
            Revisar bases legales
          </a>
        </div>
      </div>
    </div>
  </app-container>
</div>
